module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('form', {
    ref: "form",
    attrs: {
      "method": "POST",
      "action": "/api/export.php",
      "target": "_blank"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "format"
    },
    domProps: {
      "value": _vm.format
    }
  }), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "content"
    },
    domProps: {
      "value": _vm.contentWithSource
    }
  })]), _vm._v(" "), (_vm.formatSources) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "sources"
  }, _vm._l((_vm.orderedSources), function(item) {
    return _c('lit-list-item-view', {
      key: item.id,
      attrs: {
        "content": item.content,
        "label": item.label
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35ecc25b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExportContainer.vue
// module id = 1003
// module chunks = 1